module.exports = __webpack_public_path__ + "media/assets/icons/scale-of-justice-icon-purple-380dd997c90d8f39f9a9364fd76c90de.png";